__webpack_require__.p = "https://game-center-rosy.vercel.app/";